import { getEnvironmentVariables } from '@repo/shared-config/app/helper/environment-variables';
import { loadCheckoutWebComponents } from '@checkout.com/checkout-web-components';
import { useCheckoutMock } from '#checkout/checkout.mock.tsx';

const { environment } = getEnvironmentVariables();
const isTesting = environment === 'test';

export function useCheckoutSdk() {
  const loadMockCheckoutWebComponents = useCheckoutMock();

  if (isTesting && loadMockCheckoutWebComponents) {
    return loadMockCheckoutWebComponents;
  }

  return loadCheckoutWebComponents;
}
